module.exports = __webpack_public_path__ + "img/mantra-teaser.227045a4.png";